export default {"src":"/_next/static/media/youtube.02044968.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};